import WhyBlock from "./WhyBlock";
import emoji1 from "./emoji1.png"
import emoji2 from "./emoji2.png"

export default function WhyBlocks() {
    return (
        <div className="call-me-text call-me-text---why-blocks">
            <WhyBlock text="Рабочие славяне" img={emoji1} />
            <WhyBlock text="Более 5.000 отзывов" img={emoji2} />
        </div>
    );

}